import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=3fb85320"
import script from "./WithdrawModal.vue?vue&type=script&lang=js"
export * from "./WithdrawModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports